import BaseComponent from '/webresources-sources/js/components/base-component';
import { parse } from "qs";
import { defineComponent } from '/webresources-sources/js/util/jquery';

// TODO: this is a modified copy of bayern-tourism-frontend/templates/components/pages-overview/pages-overview-filter.js
export default class DsftOverviewFilter extends BaseComponent {
    properties() {
        return {
            categories: {},
        };
    }

    connected() {
        // find all categories and options + option names
        this.element.querySelectorAll('input[type=checkbox][data-category]').forEach((input) => {
            const category = $(input).data('category');
            const option = $(input).data('option');
            if (!this.categories[category]) {
                this.categories[category] = {};
            }
            this.categories[category][option] = input.checked;
        });

        this.dispatch('init-dsft-categories', {
            categories: this.categories,
            selectedCategories: this.selectedCategories,
            filteredCategories: this.filteredCategories,
        });
    }

    events() {
        return {
            window: {
                locationchange: () => {
                    let url = window.location.search;
                    let scopedUrlParameters = parse(`${url}`, { ignoreQueryPrefix: true });

                    // un-scope parameters
                    const urlParameters = {};
                    for (const parameter of Object.keys(scopedUrlParameters)) {
                        urlParameters[parameter.replace('bf-', '')] = scopedUrlParameters[parameter];
                    }

                    Object.keys(this.categories).forEach((category) => {
                        const options = this.categories[category];
                        Object.keys(options).forEach((option) => {
                            this.categories[category][option] = urlParameters[category] && urlParameters[category].includes(option);
                        });
                    });
                    this.categoriesChanged();
                    this.requestUpdate();
                },
            },
            'input[data-category]': {
                change: (e) => {
                    const input = e.target;
                    const category = $(input).data('category');
                    const option = $(input).data('option');
                    this.categories[category][option] = input.checked;
                    this.categoriesChanged();
                    this.requestUpdate();
                },
            },
            '[data-clear-filter]': {
                click: (e) => {
                    const clearInput = e.target;
                    const category = clearInput.getAttribute('data-clear-filter');

                    this.clearFilters(category !== '' ? category : undefined);
                },
            },
        };
    }

    get selectedCategories() {
        const selectedCategories = [];

        Object.keys(this.categories).forEach((category) => {
            const options = this.categories[category];
            Object.keys(options).forEach((option) => {
                const checked = this.categories[category][option];
                if (checked) selectedCategories.push({ category, option });
            });
        });

        return selectedCategories;
    }

    get filteredCategories() {
        const filteredCategories = {};

        Object.keys(this.categories).forEach((category) => {
            filteredCategories[category] = [];
            Object.keys(this.categories[category]).forEach((option) => {
                const checked = this.categories[category][option];
                if (checked) filteredCategories[category].push(option);
            });
        });

        return filteredCategories;
    }

    update() {
        this.updateInputs();
        super.update();
    }

    categoriesChanged() {
        this.dispatch('select-dsft-categories', {
            categories: this.categories,
            selectedCategories: this.selectedCategories,
            filteredCategories: this.filteredCategories,
        });
    }

    clearFilters(category = undefined) {
        if (category) {
            // only clear category
            const options = this.categories[category];
            Object.keys(options).forEach((option) => {
                this.categories[category][option] = false;
            });
        } else {
            // clear all categories
            Object.keys(this.categories).forEach((category) => {
                const options = this.categories[category];
                Object.keys(options).forEach((option) => {
                    this.categories[category][option] = false;
                });
            });
        }

        this.categoriesChanged();
        this.requestUpdate();
    }

    updateInputs() {
        Object.keys(this.categories).forEach((category) => {
            const options = this.categories[category];
            Object.keys(options).forEach((option) => {
                const checked = this.filteredCategories[category].includes(option);
                this.categories[category][option] = checked;
                const input = this.$element.find(`[data-category="${category}"][data-option="${option}"]`);
                $(input).prop('checked', checked);
            });
        });

        const clearInputs = this.element.querySelectorAll('[data-clear-filter]');
        for (const clearInput of clearInputs) {
            const category = clearInput.getAttribute('data-clear-filter');
            if (category) {
                const hasSelected = this.filteredCategories[category].length > 0;
                clearInput.checked = !hasSelected;
            }
        }
    }
}

defineComponent('dsft-overview-filter', DsftOverviewFilter);
